import { Box, Typography } from '@mui/material';
import { Tooltip } from 'components/common/Tooltip';
import { IconBoldInfoCircleAlt } from 'components/icons/components/bold/IconBoldInfoCircleAlt';
import { theme } from 'styles/theme';

export const TitleWithInfoTooltip = ({
  title,
  info,
}: {
  title: string;
  info: string;
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Typography
        variant="body-xl"
        color={theme.colors?.utility[700]}
        fontWeight={600}
      >
        {title}
      </Typography>
      <Tooltip title={info}>
        <Box component="span" display="flex" alignItems="center">
          <IconBoldInfoCircleAlt size={16} color={theme.colors?.utility[700]} />
        </Box>
      </Tooltip>
    </Box>
  );
};
